import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import toggleDynamicTabOperation from 'editor/src/store/editorModules/sidebar/operation/toggleDynamicTabOperation';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import { setTextLibraryAction } from '../slice';
import sanitizeTextLibraryPayload from '../util/sanitizeTextLibraryPayload';

/**
 * Handles `textLibrary.setEntries`. The text library tab only exists while the host has sent at
 * least one valid entry; it is placed right after the Text tab when that tab is present.
 */
const setTextLibraryOperation = (payload: unknown) => (dispatch: ThunkDispatch) => {
  const data = sanitizeTextLibraryPayload(payload);
  batch(() => {
    dispatch(setTextLibraryAction(data));
    // the host may send this at any time: keep the customer's open tab open
    dispatch(
      toggleDynamicTabOperation(TAB_NAMES.TEXT_LIBRARY, data.entries.length > 0, undefined, {
        after: TAB_NAMES.TEXTS,
        keepActiveTab: true,
      }),
    );
  });
};

export default setTextLibraryOperation;
